// @flow
import React, { PureComponent } from 'react';

import SourceLink from '../SourceLink';
import MethodList from '../MethodList';
import Description from '../Description';
import PropertyList from '../PropertyList';
import { S } from '../../pages/Docs';
import type { API as APIType } from '../../reducers/version';

type Props = APIType & {
  version: string;
  showPrivateAPI: boolean;
};

class API extends PureComponent<Props, Props, void> {
  static defaultProps = {
    name: '',
    slug: '',
    file: '',
    line: 0,
    version: 'latest',
    methods: [],
    isPrivate: false,
    properties: [],
    description: '',
    showPrivateAPI: false
  };

  render() {
    const {
      props: {
        name,
        file,
        line,
        version,
        description,
        showPrivateAPI
      }
    } = this;

    let {
      props: {
        methods,
        properties
      }
    } = this;

    let descriptionContent = () => (
      <Description
        className={`pt2 pb3 mt0 mb3 ${S.borderBottom}`}
        content={description}
      />
    );

    if (!description) {
      descriptionContent = () => <div className="pa0 mt0 mb3" />;
    }

    if (!showPrivateAPI) {
      methods = methods.filter(({ isPrivate }) => !isPrivate);
      properties = properties.filter(({ isPrivate }) => !isPrivate);
    }

    return (
      <div>
        <div className={`pb3 ${S.borderBottom}`}>
          <h2 className="mt0 mb1">
            {name}
          </h2>
          <SourceLink file={file} line={line} />
        </div>
        {descriptionContent()}
        <PropertyList properties={properties} version={version} />
        <MethodList methods={methods} version={version} />
      </div>
    );
  }
}

export default API;



// WEBPACK FOOTER //
// ./src/components/API/index.jsx